export enum DeliveryPackageStatus {
  WAITING_FOR_PICKUP = 1,
  OUT_FOR_DELIVERY = 2,
  DELIVERED = 3,
  DELETED = 4,
  ASSIGNED = 5,
}
